import React from 'react'
import { Button, Modal, Icon } from 'antd'

const SolarInverterValidationDialog = ({
  visible,
  onYes = _ => _,
  onNo = _ => _,
  onHide = _ => _,
  onRevertData = _ => _,
}) => {
  return (
    <Modal
      title="Save?"
      visible={visible}
      onCancel={onHide}
      footer={[
        <Button
          key="Yes"
          onClick={() => {
            onHide()
            onYes()
            onNo()
          }}
        >
          Yes
        </Button>,
        <Button
          key="No"
          onClick={() => {
            onHide()
            onRevertData()
            onNo()
          }}
        >
          No
        </Button>,
        <Button key="cancle" onClick={onHide}>
          Cancel
        </Button>,
      ]}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon
          type="question-circle"
          theme="twoTone"
          style={{
            fontSize: '40px',
            marginLeft: '10px',
            marginRight: '15px',
          }}
        />{' '}
        Data has been modified, do you want to save?
      </div>
    </Modal>
  )
}

export default SolarInverterValidationDialog
